import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysUser } from '../queryKeys';

import { createUserAdmin } from './createUserAdmin';
import {
  type CreateUserMutationOptions,
  type CreateUserPayload,
} from './types';

/**
 * Custom hook for creating a new user as ADMIN.
 *
 * @returns {Object} An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin/operation/create_user_vadmin_users_post
 */
export const useMutationCreateUserAdmin = (
  options?: CreateUserMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userData: CreateUserPayload) =>
      createUserAdmin(userData),
    onSettled() {
      queryClient.invalidateQueries({ queryKey: queryKeysUser.getAllAdmin() });
    },
    ...options,
  });
};
